(function(window, undefined){
  var $ = jQuery;
  var GZ = GZ || {};
